import React, { createContext, useContext, useEffect, useState } from "react";
import API from "../utils/api";

const CurrencyContext = createContext();

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}

export function CurrencyProvider({ children }) {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let isMounted = true;
    let retryTimeout;

    const fetchCurrencies = async () => {
      try {
        const response = await API.getCurrencies();

        if (isMounted && response.data && Array.isArray(response.data)) {
          setCurrencies(response.data);
          setRetryCount(0); // Reset retry count on success
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
        
        // Retry logic: if currencies is empty and retries < 3, try again
        if (isMounted && currencies.length === 0 && retryCount < 3) {
          retryTimeout = setTimeout(() => {
            if (isMounted) {
              setRetryCount(prev => prev + 1);
            }
          }, 1000); // Retry after 1 second
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCurrencies();

    return () => {
      isMounted = false;
      if (retryTimeout) {
        clearTimeout(retryTimeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryCount]); // Re-run when retryCount changes

  return (
    <CurrencyContext.Provider value={{ currencies, loading }}>
      {children}
    </CurrencyContext.Provider>
  );
}
